<template>
    <div :class='typeClass' class='alert alert-dismissable fade show Toast' role='alert' @click='remove'>
        <div class="ToastHeader">
            <div class='ToastIcon'>
                <DisplayIcon
                    :name='toast.header'
                    :icon='toast.icon'
                />
            </div>
            <h5>{{ toastTitle }}</h5>
        </div>
        <div class='row'>
            <div class='ToastBody col-8'>
                <span>{{ toast.message }}</span><br/>
                <span>{{ toast.product.sku }}</span><br/>
                <span v-if='toast.reference'>REF: {{toast.reference}}</span><br/>
                <span>{{displayTime}}</span>
            </div>
            <div class='ToastImg col-4'>
                <div v-if='productImage' class='ImgWrap'>
                    <img :src='productImage'/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DisplayIcon from '../../../icons/DisplayIcon';
export default{
    name:'Toast',
    props:['toast'],
    components:{
        DisplayIcon
    },
    data(){
        return{
            interval: null,
            timeStarted: Date.now(),
            dateToday: new Date().getDate(),
            displayTime: '',
            productImage: this.$props.toast.product.img || this.$props.toast.product.image,
            transactionTime: this.$props.toast.product.timeAdded || this.$props.toast.timeStamp
        };
    },
    computed:{
        typeClass() {
            if(this.$props.toast.type.includes('rror')){
                return 'alert-error'
            }else{
                return `alert-${this.toast.type}`
            }
        },
        toastTitle(){
            if (this.$props.toast.type.includes('ransfer')){
                return (this.$props.toast.type.includes('uccess') || this.$props.toast.type.includes('omplete')) ? this.$props.toast.product.sku + ' Transferred Succesfully' : 'Unable to Transfer'
            }else{
                return this.$props.toast.type;
            }
        },
        dateYesterday(){
            return new Date().setDate(this.dateToday - 1)
        },
        hasError(){
            if(this.$props.notificationObject){
                return this.$props.notificationObject.status.toString().includes('rror') ? true : false;
            }else{
                return this.$props.toast.status.includes('rror')  ? true : false;
            }
        },
        elapsedTime(){
            return Math.floor((this.timeStarted - this.transactionTime) / 1000)
        },
        notificationDate(){
            return new Date(this.transactionTime).getDate()
        },
        notificationTime(){
            return new Date(this.transactionTime).toLocaleTimeString()
        },
        notificationMonth(){
            switch(new Date(this.transactionTime).getMonth()){
                case 0: return 'Jan'
                case 1: return 'Feb'
                case 2: return 'Mar'
                case 3: return 'Apr'
                case 4: return 'May'
                case 5: return 'June'
                case 6: return 'July'
                case 7: return 'Aug'
                case 8: return 'Sept'
                case 9: return 'Oct'
                case 10: return 'Nov'
                case 11: return 'Dec'
            }
        }
    },
    created(){
        this.showDisplayTime();
        this.interval = setInterval(this.showDisplayTime, 1000);
    },
    beforeDestroy(){
        clearInterval(this.interval);
    },
    methods:{
        remove(){
            this.$store.dispatch('Navigation/removeToast', this.toast);
        },
        showDisplayTime(){
            this.timeStarted = Date.now();
            if(this.elapsedTime < 2){
                this.displayTime = "Just Now"
            }else if(this.elapsedTime < 60){
                this.displayTime = " less than a minute ago";
            }else if(this.elapsedTime < 120){
                this.displayTime = Math.floor(this.elapsedTime / 60) + " minute ago ";
            }else if(this.elapsedTime < 3600){
                this.displayTime =  Math.floor(this.elapsedTime / 60) + " minutes ago";
            }else if(this.elapsedTime < 7200){
                this.displayTime = "1 hour ago"
            }else if((this.dateToday == this.notificationDate) && (this.elapsedTime < 86400)){
                this.displayTime = Math.floor(this.elapsedTime / 3600) + " hours ago"
            }else if(this.dateToday != this.notificationDate){
                this.displayTime = this.notificationMonth+" "+this.notificationDate+" at "+this.notificationTime
            }else{
                this.displayTime = this.notificationMonth+" "+this.notificationDate+" at "+this.notificationTime
            }
        }
    }
}

</script>